import styled, { css } from 'styled-components';
import { focusRing, noSelect } from '../../../../../styles/mixins';

const labelInMultipleLines = css`
  position: relative;
  min-height: 24px;
  height: auto;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;

    .checkbox-toggle-html {
      white-space: initial;
      line-height: inherit;
      height: auto;
      display: block;
      width: calc(100% - 4px);
      padding-right: 8px;
    }
  }
`;

export const LabelStyled = styled.label<{ value: boolean; disabled?: boolean }>`
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: row;
  outline: none;
  ${noSelect};
  ${labelInMultipleLines};

  svg {
    transition-duration: 0.2s, 0.2s;
    transition-timing-function: ease-in, ease-out;

    rect {
      fill: #fff;
      stroke-width: 1;
      stroke: ${({ theme }) => theme.kallisto.color.common.black[200]};
    }
  }

  &:hover,
  &:focus {
    svg {
      rect {
        stroke: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
      }
    }
  }

  &:hover,
  &:focus {
    .oss-ui-checkbox-toggle-back {
      ${({ value }) =>
        value
          ? css`
              background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
            `
          : css`
              background-color: ${({ theme }) => theme.kallisto.color.common.black[200]};
            `}
    }
    .oss-ui-checkbox-toggle-dot {
      ${({ value }) =>
        value
          ? css`
              background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
            `
          : css`
              background-color: ${({ theme }) => theme.kallisto.color.common.black[200]};
            `}
    }
  }

  &:focus-visible {
    [class*='ToggleCircle'] {
      ${focusRing}
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      .oss-ui-checkbox-toggle-back,
      .oss-ui-checkbox-toggle-dot {
        opacity: 0.5;
      }
    `}
`;

export const Text = styled.div`
  width: 100%;
`;
